import { Dispatch, useEffect, useReducer } from "react";

import reduceFilter, { FilterReducerAction } from "./reducer";
import { IFilter, IFilterElement } from "./types";

export type UseFilter<T extends string> = [
  Array<IFilterElement<T>>,
  Dispatch<FilterReducerAction<T>>,
  () => void
];

function useFilter<T extends string>(initialFilter: IFilter<T>): UseFilter<T> {
  const [data, dispatchFilterAction] = useReducer<
    React.Reducer<IFilter<T>, FilterReducerAction<T>>
  >(reduceFilter, initialFilter);

  const reset = () => {
    const temp_array = initialFilter.map(each => ({
      ...each,
      active: false,
      value: []
    }));
    temp_array.forEach((e, index) => {
      if (e.numTextfield !== undefined) {
        Object.keys(temp_array[index].numTextfield).forEach(e => {
          temp_array[index].numTextfield[e].value = undefined;
          temp_array[index].numTextfield[e].active = false;
        });
      }
    });
    dispatchFilterAction({
      payload: {
        new: temp_array
      },
      type: "reset"
    });
  };

  const refresh = () =>
    dispatchFilterAction({
      payload: {
        new: initialFilter
      },
      type: "merge"
    });

  useEffect(refresh, [initialFilter]);

  return [data, dispatchFilterAction, reset];
}

export default useFilter;
